import React from "react";
import { Crown } from "lucide-react";

// A small gold crown that marks Ko-fi supporters across chat, leaderboards & cards.
export function SupporterBadge({ tier, size = 12, showLabel = false, className = "" }) {
  return (
    <span
      data-testid="supporter-badge"
      title={tier ? `${tier} — TaskScape Supporter` : "TaskScape Supporter"}
      className={`inline-flex items-center gap-0.5 align-middle text-[#FFD700] ${className}`}
    >
      <Crown size={size} className="fill-[#FFD700]" style={{ filter: "drop-shadow(1px 1px 0 #000)" }} />
      {showLabel && <span className="osrs-num text-[10px] uppercase text-[#FFD700]">Supporter</span>}
    </span>
  );
}

export default SupporterBadge;
